import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@alwindows/shared/styles'
import { CartIcon } from './CartIcon'
import './CartIcon.scss'

const root = document.getElementById('al-cart-icon-root')
if (root) {
  relocateIntoHeader(root)
  createRoot(root).render(
    <StrictMode>
      <CartIcon />
    </StrictMode>,
  )
}

/**
 * Walk the theme DOM to find a sensible nav anchor and move the mount point
 * there. Tried in order:
 *   1. Right after `.header__search-close` — the cart sits to the right of
 *      the search affordance in the supplementary nav (preferred placement).
 *   2. Last child of `.nav-primary__supplementary` — fallback if the theme
 *      doesn't render the search toggle for this template.
 *   3. No-op — leave the mount where WordPress placed it, inline in flow.
 */
function relocateIntoHeader(mount: HTMLElement): void {
  mount.classList.add('al-cart-icon--inline')

  const searchClose = document.querySelector('.header__search-close')
  if (searchClose?.parentElement) {
    searchClose.parentElement.insertBefore(mount, searchClose.nextSibling)
    return
  }

  const supp = document.querySelector('.nav-primary__supplementary')
  if (supp) {
    supp.appendChild(mount)
  }
}
